<div class="rds-c-vd-container" fxLayout="row" fxLayoutAlign="start center">
  <div class="rds-c-vd-min" tabindex="0">
    <span class="sr-only" i18n>The minimum is {{statSet.min | rdsNumberTrunc}}</span>
    <div fxLayout="column" fxLayoutAlign="space-evenly center" matTooltip="{{statSet.min}}" matTooltipPosition="right" aria-hidden="true">
      <span> {{ statSet.min | rdsNumberTrunc }} </span>
      <label> MIN </label>
    </div>
  </div>

  <div #line class="rds-c-vd-line" fxFlex>
    <div *ngIf="!!statSet.standardDeviation" class="rds-c-vd-sd" [ngStyle]="{'left': meanLeft, 'width': sdWidth }" tabindex="0">
      <span class="sr-only" i18n>The standard deviation is {{statSet.standardDeviation | rdsNumberTrunc}}</span>
      <div fxLayout="column" fxLayoutAlign="space-evenly center" aria-hidden="true">
        <label> STANDARD DEVIATION </label>
        <span> {{ statSet.standardDeviation | rdsNumberTrunc }} </span>
        <div class="rds-c-vd-sdBox" [ngStyle]="{ 'border-width': statSet.standardDeviation === 0 && '0px', 'clip': sdTrunc }"></div>
      </div>
    </div>

    <div *ngIf="!!statSet.mean" class="rds-c-vd-mean-container" [ngStyle]="{'left': meanLeft}" tabindex="0">
      <span class="sr-only" i18n>The mean is {{statSet.mean | rdsNumberTrunc}}</span>
      <div fxLayout="column" fxLayoutAlign="start center" matTooltip="{{statSet.mean}}" matTooltipPosition="right" aria-hidden="true">
        <span class="rds-c-vd-mean-value">{{ statSet.mean | rdsNumberTrunc }}</span>
        <div class="rds-c-vd-mean-shape"></div>
        <label class="rds-c-vd-mean-label">MEAN</label>
      </div>
    </div>
  </div>

  <div class="rds-c-vd-max" tabindex="0">
    <span class="sr-only" i18n>The maximum is {{statSet.max | rdsNumberTrunc}}</span>
    <div fxLayout="column" fxLayoutAlign="space-evenly center" matTooltip="{{ statSet.max }}" matTooltipPosition="right" aria-hidden="true">
      <span> {{ statSet.max | rdsNumberTrunc }} </span>
      <label> MAX </label>
    </div>
  </div>
</div>
